import React, { useState } from 'react'

// Vite allows importing raw file contents with ?raw suffix
import eulaText from '../../EULA.md?raw'
import licenseText from '../../LICENSE.md?raw'

export default function About() {
    const [activeTab, setActiveTab] = useState<'info' | 'eula' | 'license'>('info')

    return (
        <div className="animate-fade-in">
            <div className="flex justify-between items-center mb-lg">
                <h2>About OpenCast</h2>
            </div>

            <div className="card">
                <div className="flex gap-sm mb-md flex-wrap" style={{ borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '16px' }}>
                    <button
                        className={`btn ${activeTab === 'info' ? 'btn-primary' : 'btn-secondary'}`}
                        onClick={() => setActiveTab('info')}
                    >
                        Info
                    </button>
                    <button
                        className={`btn ${activeTab === 'eula' ? 'btn-primary' : 'btn-secondary'}`}
                        onClick={() => setActiveTab('eula')}
                    >
                        EULA
                    </button>
                    <button
                        className={`btn ${activeTab === 'license' ? 'btn-primary' : 'btn-secondary'}`}
                        onClick={() => setActiveTab('license')}
                    >
                        License
                    </button>
                </div>

                {activeTab === 'info' && (
                    <div style={{ color: 'var(--text-secondary)' }}>
                        <h3 style={{ color: 'var(--text-primary)', marginBottom: '12px' }}>OpenCast Audio Pipeline</h3>
                        <p>
                            OpenCast is a proprietary audio synthesis routing engine developed by Upstate Data Systems LLC.
                            It processes web articles and long-form newsletters, classifies sections utilizing advanced Large Language Models,
                            and dynamically compiles seamless, studio-quality podcast audio via Google Cloud TTS.
                        </p>

                        <div className="mt-lg p-md" style={{ background: 'rgba(0,0,0,0.2)', borderRadius: 'var(--radius-md)' }}>
                            <h4 style={{ color: 'var(--status-warning)', marginBottom: '8px' }}>Legal Notice</h4>
                            <p className="text-sm m-0">
                                This web service is the private property of <strong>Upstate Data Systems LLC</strong>.
                                All intellectual property, source code, and design architecture is strictly owned and copyrighted by Upstate Data Systems LLC.
                                Unauthorized reproduction, distribution, or reverse-engineering is expressly prohibited.
                            </p>
                        </div>
                    </div>
                )}

                {activeTab === 'eula' && (
                    <div
                        style={{
                            maxHeight: '60vh',
                            overflowY: 'auto',
                            whiteSpace: 'pre-wrap',
                            fontFamily: 'monospace',
                            fontSize: '0.85rem',
                            color: 'var(--text-secondary)',
                            background: 'rgba(0,0,0,0.3)',
                            padding: '16px',
                            borderRadius: 'var(--radius-md)'
                        }}
                    >
                        {eulaText}
                    </div>
                )}

                {activeTab === 'license' && (
                    <div
                        style={{
                            maxHeight: '60vh',
                            overflowY: 'auto',
                            whiteSpace: 'pre-wrap',
                            fontFamily: 'monospace',
                            fontSize: '0.85rem',
                            color: 'var(--text-secondary)',
                            background: 'rgba(0,0,0,0.3)',
                            padding: '16px',
                            borderRadius: 'var(--radius-md)'
                        }}
                    >
                        {licenseText}
                    </div>
                )}
            </div>
        </div>
    )
}
